import { render, staticRenderFns } from "./AssignExpertModal.vue?vue&type=template&id=cf0f36c2&scoped=true&"
import script from "./AssignExpertModal.vue?vue&type=script&lang=js&"
export * from "./AssignExpertModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignExpertModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AssignExpertModal.vue?vue&type=style&index=1&id=cf0f36c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0f36c2",
  null
  
)

export default component.exports